import { render, staticRenderFns } from "./groupSetting.vue?vue&type=template&id=3fff6e0d&"
import script from "./groupSetting.vue?vue&type=script&lang=js&"
export * from "./groupSetting.vue?vue&type=script&lang=js&"
import style0 from "./groupSetting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports